import { useEffect, useRef, useState } from 'react'
import { UserCircleIcon } from 'components/icons'

const CustomerProfileImageUpload = ({
  value,
  onChange = () => { },
}: {
  value?: string,
  onChange: (file: File) => void
}) => {
  const fileRef = useRef<HTMLInputElement>(null)

  const [file, setFile] = useState<File | undefined>()
  const [previewUrl, setPreviewUrl] = useState<string | undefined>(value)

  const handleButtonClick = () => {
    if (!fileRef.current) { return }

    fileRef.current.click()
  }

  useEffect(() => {
    if (!file) { return }

    onChange(file)
    setPreviewUrl(URL.createObjectURL(file))

    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl)
      }
    }
  }, [file])

  return (
    <div className="relative flex flex-col items-center gap-10">
      <div className="h-100 w-100">
        {
          previewUrl
            ? <img src={previewUrl} alt="" className="object-cover w-full h-full rounded-full" />
            : <UserCircleIcon className="w-full h-full rounded-full" />
        }
      </div>

      <button
        type="button"
        className="font-normal underline cursor-pointer text-grey-700 focus:text-primary focus:outline-none"
        onClick={handleButtonClick}
      >
        Upload
      </button>

      <input
        type="file"
        accept="image/*"
        className="hidden"
        ref={fileRef}
        onChange={e => setFile(e.target.files?.[0])}
      />
    </div>
  )
}

export default CustomerProfileImageUpload
